




















































































import AudioGroupViewModel from "@models/meditations/create/audioGroupViewModel";
import MeditationAudioViewModel from "@models/meditations/create/meditationAudioViewModel";
import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";

@Component
export default class AddAudioGroupComponent extends Vue {  
  @Prop({type: Boolean, default: true}) audioRequired: boolean;
  @Prop({type: Boolean, default: false}) showDescription: boolean;
  @Prop({type: Object}) audioGroup: AudioGroupViewModel;
  @Prop({default: false}) edit: boolean;
  currentAudioGroup: AudioGroupViewModel = null;
  @Watch('audioGroup')
  onChangeAudioGroup() {    
    this.currentAudioGroup = this.audioGroup == null ? null : this.audioGroup.clone();
  }
  @Watch('edit')
  editUpdate(newValue: boolean) {
    if(newValue) {
      this.currentAudioGroup = this.audioGroup == null ? null : this.audioGroup.clone();
    }
  }
  removeAudio(item: MeditationAudioViewModel) {
    item.audioFile = null;
    item.base64File = null;
    item.audioUrl = null;
  }
  emit() {
    this.$emit('change', this.currentAudioGroup);
  }
  cancelAddAudio() {
    this.currentAudioGroup = null;
    this.emit();
  }
  onOkAudioModal() {
    const isValid = (this.$refs.audioValidator as any).isValid();
    if (!isValid) return;
    this.emit();
    this.currentAudioGroup = null;
  }
}
